import { render, staticRenderFns } from "./VoteSuccessModal.vue?vue&type=template&id=3ea3c528"
import script from "./VoteSuccessModal.vue?vue&type=script&lang=ts"
export * from "./VoteSuccessModal.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports